import { Box } from '@chakra-ui/react';
import FullCalendar from '@fullcalendar/react';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import moment from 'moment';
import Cookies from 'universal-cookie';

import useGetHostCalendarSchedule from 'Domain/host/useGetHostCalendarSchedule';

import { syncCalendarWithSelectedDate } from 'View/schedule/helper/syncCalendarWithSelectedDate';
import { useHostScheduleState } from 'View/host-schedule/state';
import HeaderCalendar from 'View/host-schedule/component/header-calendar';
import SlotContent from 'View/schedule/component/slot-content';
import Card from 'View/schedule/component/card';
import { eventTimeFormat, slotLabelFormat } from 'View/schedule/section/calendar/const';

import styles from './styles.module.css';
import './styles.css';

const Calendar = () => {
  const calendarRef = useRef();
  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;
  const navigate = useNavigate();
  const { filterState } = useHostScheduleState();

  const { data: schedules } = useGetHostCalendarSchedule(filterState?.dateRangeCalendar);

  const initialDate = moment.tz(filterState?.dateRangeCalendar?.startDate, timezone).format('YYYY-MM-DD');

  useEffect(() => {
    if (!calendarRef?.current) return;

    requestAnimationFrame(() => syncCalendarWithSelectedDate(calendarRef, filterState?.dateRangeCalendar, filterState?.calendarType));
  }, [calendarRef, filterState?.dateRangeCalendar, filterState?.calendarType]);

  return (
    <Box className={styles['schedule__container']}>
      <Box className={`calendar__container  ${styles['schedule__calendar']}`}>
        <FullCalendar
          events={schedules}
          ref={calendarRef}
          plugins={[timeGridPlugin, interactionPlugin]}
          initialView={'timeGridFourDay'}
          initialDate={initialDate}
          views={{ timeGridFourDay: { type: 'timeGrid', duration: { days: filterState?.calendarType.value } } }}
          allDaySlot={false}
          weekends={true}
          headerToolbar={false}
          slotEventOverlap={false}
          dayHeaderContent={(date) => <HeaderCalendar date={date} />}
          slotLabelContent={(time) => <SlotContent time={time} />}
          eventContent={(eventInfo) => <Card info={eventInfo} onCardClick={() => navigate(`/host/detail/${eventInfo.event.id}`)} />}
          eventTimeFormat={eventTimeFormat}
          slotLabelFormat={slotLabelFormat}
          axisFormat="HH:mm"
          locale="en-GB"
          eventOverlap={true}
          height={'calc(100vh - 325px)'}
        />
      </Box>
    </Box>
  );
};

export default Calendar;
